import { createContext } from "react";

export const theCars = createContext("");
